module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/Training/training-approval/training-approval-grid/training-approval-grid.component.css
// module id = ./src/app/hrms/Training/training-approval/training-approval-grid/training-approval-grid.component.css
// module chunks = main